export enum BeneficiaryLink {
  PARTNER = 'PARTNER',
  HUSBAND = 'HUSBAND',
  WIFE = 'WIFE',
  FATHER = 'FATHER',
  MOTHER = 'MOTHER',
  BROTHER = 'BROTHER',
  SISTER = 'SISTER',
  SON = 'SON',
  DAUGHTER = 'DAUGHTER',
  GRAND_SON = 'GRAND_SON',
  GRAND_DAUGHTER = 'GRAND_DAUGHTER',
  GRAND_FATHER = 'GRAND_FATHER',
  GRAND_MOTHER = 'GRAND_MOTHER',
  NEPHEW = 'NEPHEW',
  NIECE = 'NIECE',
  GODSON = 'GODSON',
  GODDAUGHTER = 'GODDAUGHTER',
  FATHER_OF_MY_CHILDREN = 'FATHER_OF_MY_CHILDREN',
  MOTHER_OF_MY_CHILDREN = 'MOTHER_OF_MY_CHILDREN',
  FRIEND = 'FRIEND',
  UNCLE = 'UNCLE',
  AUNT = 'AUNT',
}
